import { SelectFarm } from '@components/Header/SelectFarm';
import { FarmContext } from '@context/FarmContext';
import { type ReactNode, useContext } from 'react';
import { FiAlertTriangle, FiHome, FiPlus, FiSettings } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import {
  EmptyStateAction,
  EmptyStateCard,
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateWrapper,
} from './style';

type ConfirmInfosProps = {
  children: ReactNode;
  farms?: boolean;
  farm?: boolean;
  scores?: boolean;
};

export default function ConfirInfosError({ children, farms, farm, scores }: ConfirmInfosProps) {
  const { farms: farmList, farm: selectedFarm, farmInfo } = useContext(FarmContext);
  const hasFarms = farmList && farmList.length > 0;
  const hasFarm = selectedFarm !== undefined;
  const hasScores = farmInfo?.scores && farmInfo.scores.length > 0;

  if (farms && !hasFarms) {
    return (
      <EmptyStateWrapper>
        <EmptyStateCard>
          <EmptyStateIcon $variant="warning">
            <FiHome />
          </EmptyStateIcon>
          <EmptyStateTitle>Nenhuma fazenda cadastrada</EmptyStateTitle>
          <EmptyStateDescription>
            Cadastre sua primeira fazenda para começar a utilizar o sistema.
          </EmptyStateDescription>
          <Link style={{ textDecoration: 'none' }} to="/fazendas">
            <EmptyStateAction>
              <FiPlus />
              Nova fazenda
            </EmptyStateAction>
          </Link>
        </EmptyStateCard>
      </EmptyStateWrapper>
    );
  }

  if (farm && !hasFarm) {
    return (
      <EmptyStateWrapper>
        <EmptyStateCard>
          <EmptyStateIcon $variant="info">
            <FiAlertTriangle />
          </EmptyStateIcon>
          <EmptyStateTitle>Selecione uma fazenda</EmptyStateTitle>
          <EmptyStateDescription>
            Escolha uma fazenda no seletor abaixo para acessar as ferramentas.
          </EmptyStateDescription>
          <SelectFarm />
        </EmptyStateCard>
      </EmptyStateWrapper>
    );
  }

  if (scores && !hasScores) {
    return (
      <EmptyStateWrapper>
        <EmptyStateCard>
          <EmptyStateIcon $variant="warning">
            <FiSettings />
          </EmptyStateIcon>
          <EmptyStateTitle>Scores não configurados</EmptyStateTitle>
          <EmptyStateDescription>
            Configure os scores de cocho na fazenda para utilizar esta funcionalidade.
          </EmptyStateDescription>
          <Link style={{ textDecoration: 'none' }} to="/fazendas">
            <EmptyStateAction>
              <FiSettings />
              Configurar scores
            </EmptyStateAction>
          </Link>
        </EmptyStateCard>
      </EmptyStateWrapper>
    );
  }

  return <>{children}</>;
}
